/* unplugin-vue-components disabled */import { render } from "./PopupAppShare.vue?vue&type=template&id=32898525"
import script from "./PopupAppShare.vue?vue&type=script&lang=js"
export * from "./PopupAppShare.vue?vue&type=script&lang=js"

import "./PopupAppShare.vue?vue&type=style&index=0&id=32898525&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__